


/**
 * Apply a grab and drag scroll behavior to a selectable set of elements.
 *
 * @param containerId id of the table's container used to check if scroll is possible in the x-axis
 * @param selector a selector used to apply the behavior to a set of elements (usually tables)
 */
export function useDraggableTable(containerId, selector = `#${containerId} table`) {
	const container = document.getElementById(containerId);

	function isOverflowX(element) {
		return element.offsetWidth > container.offsetWidth;
	}

	// Draggable horizontal scroll bar for table
	let isMouseDown = false;
	let startX, scrollLeft;
	document
		.querySelectorAll(selector)
		.forEach(table => {
			function startDragging(mousePosition) {
				isMouseDown = true;
				startX = mousePosition.pageX - table.offsetLeft;
				scrollLeft = table.scrollLeft;
			}

			function stopDragging() {
				return isMouseDown = false;
			}

			function move(mouseMove) {
				mouseMove.preventDefault();
				if (!isMouseDown) {
					return;
				}
				const scroll = mouseMove.pageX - table.offsetLeft - startX;
				table.scrollLeft = scrollLeft - scroll;
			}

			if (isOverflowX(table)) {
				table.style.display = "block"
				table.style.overflowX = "auto"
				table.style.cursor = "grab"
			}

			table.addEventListener('mousemove', move);

			table.addEventListener('mousedown', startDragging);

			table.addEventListener('mouseup', stopDragging);
			table.addEventListener('mouseleave', stopDragging);
		})
}
